import * as actionTypes from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';
import { SET_START_TIME } from 'store/reducers/appointment/actionTypes';
import {
  SET_LAST_TIMESLOT_SELECTED,
  SELECTED_TIMESLOT_IN_PROMO_RANGE
} from 'store/reducers/userInteractions/actionTypes';

export default function(state = initialState.userInteractions, action) {
  switch (action.type) {
    // Private Route
    case actionTypes.SET_PRIVATE_ROUTE: {
      return { ...state, privateRoute: action.payload };
    }
    case actionTypes.SET_LOADING_APPOINTMENT: {
      return { ...state, isLoadingAppointment: action.payload };
    }
    // page Appointment
    case actionTypes.SET_APPOINTMENT_FILTER_DAYS_BY: {
      const pageAppointment = {
        ...state.pageAppointment,
        filterDaysBy: action.payload
      };
      return { ...state, pageAppointment };
    }
    case actionTypes.SET_APPOINTMENT_SELECTED_DAY: {
      const pageAppointment = {
        ...state.pageAppointment,
        selectedDay: action.payload
      };
      return { ...state, pageAppointment };
    }
    case actionTypes.CLEAR_APPOINTMENT_SELECTED_DAY: {
      const pageAppointment = {
        ...state.pageAppointment,
        selectedDay: null
      };
      return { ...state, pageAppointment };
    }
    case actionTypes.SET_GTM_FIRST_AVAILABLE_TIMESLOT: {
      const pageAppointment = {
        ...state.pageAppointment,
        gtmFirstAvailableTimeslot: action.payload
      };
      return { ...state, pageAppointment };
    }
    case actionTypes.SET_NO_FINDS_ALERT_SHOWN: {
      const pageVehicle = {
        ...state.pageVehicle,
        noFindsAlertShown: action.payload
      };
      return { ...state, pageVehicle };
    }
    case actionTypes.SET_SHOW_MOBILE_FOOTER: {
      const pageVehicle = {
        ...state.pageVehicle,
        showMobileFooter: action.payload
      };
      return { ...state, pageVehicle };
    }
    case actionTypes.SET_VEHICLE_PAGE_REVISIT: {
      const pageVehicle = {
        ...state.pageVehicle,
        vehiclePageRevisit: action.payload
      };
      return { ...state, pageVehicle };
    }
    case actionTypes.SET_IDK_SELECTED: {
      const pageVehicle = {
        ...state.pageVehicle,
        idkSelected: action.payload
      };
      return { ...state, pageVehicle };
    }
    case actionTypes.SET_TRIMS_SELECTED_POSITION: {
      const pageVehicle = {
        ...state.pageVehicle,
        trimsSelectedPosition: action.payload
      };
      return { ...state, pageVehicle };
    }
    // page Review
    case actionTypes.SET_CONTACT_INFO_MISSING: {
      const pageReview = {
        ...state.pageReview,
        contactInfoMissing: action.payload
      };
      return { ...state, pageReview };
    }
    case actionTypes.SET_CONTACT_INFO_FORM_VALID: {
      return { ...state, contactInfoFormValid: action.payload };
    }
    // Application Flow
    case actionTypes.SET_APP_FLOW: {
      return { ...state, appFlow: action.payload };
    }
    // Application Name
    case actionTypes.SET_APP_NAME: {
      return { ...state, appName: action.payload };
    }
    // Reset State
    case RESET_APP_STATE:
      return {
        ...initialState.userInteractions,
        privateRoute: state.privateRoute,
        startEventSent: state.startEventSent,
        quickAppointment: state.quickAppointment,
        appName: state.appName
      };
    // Modify
    case actionTypes.SET_MODIFY_ENABLED: {
      return { ...state, modifyEnabled: action.payload };
    }
    case actionTypes.SET_APPT_MODIFIED: {
      return { ...state, apptModified: action.payload };
    }
    case actionTypes.SET_START_EVENT_SENT: {
      return { ...state, startEventSent: action.payload };
    }
    case actionTypes.SET_NO_LONGER_AVAILABLE_DATE: {
      const pageAppointment = {
        ...state.pageAppointment,
        noLongerAvailableDate: action.payload
      };
      return { ...state, pageAppointment };
    }
    case SET_START_TIME: {
      if (action.payload) {
        const pageAppointment = {
          ...state.pageAppointment,
          lastTimeslotSelected: action.payload
        };
        return { ...state, pageAppointment };
      }
      return state;
    }
    case SET_LAST_TIMESLOT_SELECTED: {
      const pageAppointment = {
        ...state.pageAppointment,
        lastTimeslotSelected: action.payload
      };
      return { ...state, pageAppointment };
    }

    case SELECTED_TIMESLOT_IN_PROMO_RANGE: {
      const pageAppointment = {
        ...state.pageAppointment,
        selectedTimeslotInPromoRange: action.payload
      };
      return { ...state, pageAppointment };
    }

    case actionTypes.SET_POPULATE_MOBILE_PHONE_NUMBER: {
      return { ...state, populateMobilePhoneNumber: action.payload };
    }
    // Find me
    case actionTypes.SET_SEARCH_CRITERIA_FIND_ME: {
      return { ...state, searchCriteriaFindMe: action.payload };
    }
    // Self check in
    case actionTypes.SET_SELF_CHECK_IN_ENABLED: {
      return { ...state, selfCheckinEnabled: action.payload };
    }
    case actionTypes.SET_SELF_CHECK_IN_EXTENDED_ENABLED: {
      return { ...state, selfCheckinExtendedEnabled: action.payload };
    }
    // Labels
    case actionTypes.SET_MODEL_LABEL_OTHER: {
      return { ...state, modelLabelOther: action.payload };
    }
    case actionTypes.SET_MAKE_LABEL_OTHER: {
      return { ...state, makeLabelOther: action.payload };
    }
    case actionTypes.SET_QUICK_APPT_ENABLED: {
      const quickAppointment = {
        ...state.quickAppointment,
        isQuickApptEnabled: action.payload
      };
      return { ...state, quickAppointment };
    }
    case actionTypes.SET_LOCALIZED_QUICK_APPT_SERVICE: {
      const quickAppointment = {
        ...state.quickAppointment,
        localizedQuickApptService: action.payload
      };
      return { ...state, quickAppointment };
    }
    // GUID
    case actionTypes.SET_GUID: {
      return { ...state, guid: action.payload };
    }
    // Mobile Phone
    case actionTypes.SET_SAVED_MOBILE: {
      return { ...state, savedMobile: action.payload };
    }
    // ReCaptcha
    case actionTypes.SET_RECAPTCHA_TOKEN: {
      return { ...state, recaptchaToken: action.payload };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/userInteractions/reducer.js